import { useState, useEffect, useRef } from "react";

// // WordPress site URL
// const WP_API_BASE = "https://syntropypro.com/wp-json/satp/v1";

// ── Brand tokens ──────────────────────────────────────────────────────────────
const C = {
  darkGreen:  "#052C0C",
  limeGreen:  "#9ACA44",
  oliveGreen: "#819951",
  cream:      "#1D2C1E",
  white:      "#102216",
  darkBg:     "#FFFFFF",
  cardBg:     "#F7FAF4",
  borderFaint:"rgba(5,44,12,0.16)",
  textFaint:  "rgba(16,34,22,0.72)",
  textMid:    "rgba(16,34,22,0.86)",
};

// const NAV_LINKS = ["Benefits", "Products", "Testimonials", "About", "Contact"];
const NAV_LINKS = ["#/About", "#/Contact", "#/FAQ"];
const LOGO_SRC = "https://syntropypro.com/wp-content/uploads/2026/04/SATFPM-LOGO-1.png";

const BENEFITS = [
  { icon: "😴", title: "Restful Sleep", desc: "Soya’s isoflavones and nutrients help regulate hormones, calm the nervous system, and may ease insomnia — so you can wake up refreshed and recharged." },
  { icon: "🧠", title: "Boost Libido",   desc: "Rich in arginine and plant-based protein, Millennium Soya naturally enhances blood circulation and stamina. This helps restore vitality, increase confidence, and fuel passion in your intimate life." },
  { icon: "💪", title: "Digestive Ease",desc: "100% lactose-free and cholesterol-free, our soya powder is smooth on the stomach. It helps ease gastro issues like bloating and reflux while fueling your day with clean energy." },
  // { icon: "🌿", title: "Gut & Microbiome",    desc: "Pre- and probiotic formulas that restore microbial balance, improving digestion, energy, and mood." },
  // { icon: "🫀", title: "Heart & Circulation", desc: "Synergistic botanical compounds that promote healthy blood flow and support long-term cardiovascular resilience." },
  // { icon: "⚡", title: "Sustained Vitality",  desc: "Whole-food energy matrices that fuel your body without stimulant crashes or dependency." },
];

{/* ═══════════════════════════════════════════ COMMENT OUT STATS FOR NOW :: NEED MORE DETAILS */}
// const STATS = [
//   { value: "98%",  label: "Customer Satisfaction" },
//   { value: "120K+",label: "Lives Transformed"     },
//   { value: "50+",  label: "Active Compounds"       },
//   { value: "10",   label: "Years of Research"      },
// ];

const FALLBACK_TESTIMONIALS = [
  // { name: "Maria L.",  role: "Wellness Coach",    text: "After just one month, I noticed a genuine shift in my energy and clarity. SATP products have become a non-negotiable part of my daily ritual.", avatar: "ML", stars: 5 },
  // { name: "Carlos R.", role: "Physical Therapist", text: "My clients who use SATP consistently recover faster and report better mood. I confidently recommend them to everyone I work with.", avatar: "CR", stars: 5 },
  // { name: "Ana P.",    role: "Registered Nurse",   text: "As a healthcare professional I scrutinize every supplement carefully. SATP's formulas are transparent, science-backed, and they genuinely work.", avatar: "AP", stars: 5 },
  // { name: "Joel T.",   role: "Triathlete",          text: "My training load doubled yet my recovery time didn't. SATP changed what I thought was possible for my body.", avatar: "JT", stars: 5 },
  {
    src: "https://syntropypro.com/wp-content/uploads/2026/04/587cbc1375494da29cc691ee2c2d8da9.mov",
  },
  {
    src: "https://syntropypro.com/wp-content/uploads/2026/04/copy_434D6339-51F3-4010-B08D-B5268C29C334.mov",
  },
  {
    src: "https://syntropypro.com/wp-content/uploads/2026/04/Copy-of-copy_9C93E036-A65F-48C8-971C-29D0FB18C173.mov",
  },
  {
    src: "https://syntropypro.com/wp-content/uploads/2026/04/Copy-of-copy_FC9916C7-9F72-4916-9B3C-CCABAB5079B9.mov",
  },
];

// ── Testimonials hook ─────────────────────────────────────────────────────────
function useTestimonials() {
  const [testimonials, setTestimonials] = useState([]);
  // const [status, setStatus]             = useState("loading");
  const [status, setStatus]             = useState("");

  useEffect(() => {
    let cancelled = false;
    // -- COMMENT OUT LOAD FUNCTION FOR NOW BECAUSE THE API IS NOT YET SETUP IN WORDPRESS
    // async function load() {
    //   try {
    //     const res = await fetch(`${WP_API_BASE}/testimonials`, { headers: { Accept: "application/json" } });
    //     if (!res.ok) throw new Error(`HTTP ${res.status}`);
    //     const data = await res.json();
    //     if (cancelled) return;
    //     const mapped = (Array.isArray(data) ? data : []).map((t) => ({
    //       name:   t.name   || "Anonymous",
    //       role:   t.role   || "",
    //       text:   t.text   || "",
    //       avatar: t.avatar || (t.name || "?").split(" ").map((w) => w[0]).join("").slice(0, 2).toUpperCase(),
    //       stars:  Number(t.stars) || 5,
    //     }));
    //     setTestimonials(mapped.length ? mapped : FALLBACK_TESTIMONIALS);
    //     setStatus("success");
    //   } catch (err) {
    //     console.warn("Testimonials API error:", err.message);
    //     if (!cancelled) { setTestimonials(FALLBACK_TESTIMONIALS); setStatus("error"); }
    //   }
    // }
    // load();

    // TEMP SINCE API IS NOT YET SETUP
    setTestimonials(FALLBACK_TESTIMONIALS);
    return () => { cancelled = true; };
  }, []);

  return { testimonials, status };
}

// ── Sub-components ────────────────────────────────────────────────────────────
// function StarRating({ count }) {
//   return (
//     <div style={{ display: "flex", gap: 3, justifyContent: "center", marginBottom: 14 }}>
//       {Array.from({ length: count }).map((_, i) => (
//         <span key={i} style={{ color: C.limeGreen, fontSize: 15 }}>★</span>
//       ))}
//     </div>
//   );
// }

function TestimonialSkeleton() {
  const bar = (w, h, br = 4, mx = "auto", mb = 10) => ({
    width: w, height: h, borderRadius: br, background: "rgba(154,202,68,0.1)",
    animation: "shimmer 1.5s infinite", margin: `0 ${mx === "auto" ? "auto" : 0} ${mb}px`,
  });
  return (
    <div style={{ maxWidth: 700, margin: "0 auto", padding: "48px 48px 40px", border: `1px solid ${C.borderFaint}`, borderRadius: 6, background: C.cardBg }}>
      <div style={bar("60px", "10px", 100, "auto", 18)} />
      {["92%","78%","64%"].map((w,i) => <div key={i} style={bar(w, "17px", 4, "auto", 10)} />)}
      <div style={{ height: 20 }} />
      <div style={bar("52px", "52px", "50%", "auto", 12)} />
      <div style={bar("110px", "14px", 4, "auto", 8)} />
      <div style={bar("76px",  "11px", 4, "auto", 0)} />
    </div>
  );
}

// ── Main component ────────────────────────────────────────────────────────────
export default function LandingPage() {
  const [scrolled, setScrolled]                           = useState(false);
  const [menuOpen, setMenuOpen]                           = useState(false);
  const [visibleSections, setVisibleSections]             = useState({});
  const [viewportWidth, setViewportWidth]                 = useState(typeof window !== "undefined" ? window.innerWidth : 1200);
  const sectionRefs                                       = useRef({});
  const isMobile                                          = viewportWidth <= 768;
  const isTablet                                          = viewportWidth <= 1024;

  const { testimonials, status: tStatus } = useTestimonials();

  // Shrinking header
  useEffect(() => {
    window.scrollTo(0, 0);

    const fn = () => setScrolled(window.scrollY > 70);
    window.addEventListener("scroll", fn);
    return () => window.removeEventListener("scroll", fn);
  }, []);

  useEffect(() => {
    const onResize = () => {
      setViewportWidth(window.innerWidth);
      if (window.innerWidth > 768) setMenuOpen(false);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // Scroll-triggered reveal
  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => {
        if (e.isIntersecting)
          setVisibleSections((p) => ({ ...p, [e.target.dataset.section]: true }));
      }),
      { threshold: 0.12 }
    );
    Object.values(sectionRefs.current).forEach((el) => el && obs.observe(el));
    return () => obs.disconnect();
  }, []);

  const setRef  = (k) => (el) => { sectionRefs.current[k] = el; };
  const visible = (k) => visibleSections[k];

  // ── Reusable style fragments ──────────────────────────────────────────────
  const btnPrimary = {
    padding: "13px 34px",
    background: `linear-gradient(135deg, ${C.limeGreen}, ${C.oliveGreen})`,
    color: C.darkGreen, border: "none", borderRadius: 3,
    fontSize: 13, fontWeight: 700, letterSpacing: "0.1em",
    textTransform: "uppercase", cursor: "pointer", fontFamily: "inherit",
    boxShadow: "0 4px 20px rgba(154,202,68,0.3)",
    transition: "transform 0.2s, box-shadow 0.2s",
  };
  const btnOutline = {
    padding: "13px 34px", background: "transparent",
    color: C.cream, border: `1px solid rgba(230,203,161,0.35)`, borderRadius: 3,
    fontSize: 13, fontWeight: 600, letterSpacing: "0.1em",
    textTransform: "uppercase", cursor: "pointer", fontFamily: "inherit",
    transition: "border-color 0.2s, color 0.2s",
  };
  const sectionTag  = { fontSize: 11, letterSpacing: "0.28em", textTransform: "uppercase", color: C.limeGreen, marginBottom: 14 };
  const sectionHead = { fontSize: "clamp(30px,4vw,50px)", fontWeight: 300, lineHeight: 1.2, color: C.white, marginBottom: 14 };

  return (
    <div style={{ fontFamily: "'Outfit', 'Segoe UI', sans-serif", background: C.darkBg, color: C.cream, minHeight: "100vh", overflowX: "hidden" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&family=Playfair+Display:ital,wght@0,400;0,700;1,400&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        @keyframes fadeUp   { from{opacity:0;transform:translateY(22px)} to{opacity:1;transform:translateY(0)} }
        @keyframes shimmer  { 0%,100%{opacity:.25} 50%{opacity:.5} }
        @keyframes pulse    { 0%,100%{opacity:1} 50%{opacity:.5} }
        @keyframes floatUp  { 0%{transform:translateY(0)} 50%{transform:translateY(-10px)} 100%{transform:translateY(0)} }
        @keyframes slideDown { from{opacity:0;transform:translateY(-8px)} to{opacity:1;transform:translateY(0)} }
        body { background:${C.darkBg}; }
        ::-webkit-scrollbar { width:4px; }
        ::-webkit-scrollbar-thumb { background:rgba(154,202,68,.35); border-radius:2px; }
        a { text-decoration:none; }

        /* Decorative organic blobs */
        .blob {
          position: absolute; border-radius: 50%;
          filter: blur(80px); pointer-events: none; opacity: 0.12;
        }

        /* Burger button */
        .burger-btn {
          display: none;
          flex-direction: column;
          justify-content: center;
          gap: 5px;
          background: none;
          border: none;
          cursor: pointer;
          padding: 6px;
          z-index: 1001;
        }
        .burger-btn span {
          display: block;
          width: 22px;
          height: 2px;
          background: rgba(230,203,161,0.85);
          border-radius: 2px;
          transition: transform 0.3s ease, opacity 0.3s ease;
        }
        .burger-btn.open span:nth-child(1) { transform: translateY(7px) rotate(45deg); }
        .burger-btn.open span:nth-child(2) { opacity: 0; }
        .burger-btn.open span:nth-child(3) { transform: translateY(-7px) rotate(-45deg); }

        @media (max-width: 768px) {
          .burger-btn { display: flex; }
          .desktop-nav { display: none !important; }
        }
      `}</style>

      {/* ═══════════════════════════════════════════ HEADER */}
      <header style={{
        position: "fixed", top: 0, left: 0, right: 0, zIndex: 999,
        background: "rgba(5,44,12,0.96)",
        backdropFilter: "blur(14px)",
        borderBottom: `1px solid ${C.borderFaint}`,
        transition: "all 0.4s cubic-bezier(0.4,0,0.2,1)",
      }}>
        {/* Top bar: logo + burger (mobile) or logo + nav (desktop) */}
        <div style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: scrolled ? (isMobile ? "10px 16px" : "10px 52px") : (isMobile ? "14px 16px" : "22px 52px"),
          transition: "padding 0.4s cubic-bezier(0.4,0,0.2,1)",
        }}>
          {/* Logo */}
          <div style={{ display: "flex", alignItems: "center", gap: 12, cursor: "pointer" }}>
            <img
              src={LOGO_SRC}
              alt="Syntropy Alliance Trade"
              style={{
                height: scrolled ? 38 : 52,
                width: "auto",
                transition: "height 0.4s ease",
                filter: "drop-shadow(0 2px 8px rgba(154,202,68,0.25))",
              }}
            />
            <div>
              <div style={{ fontSize: scrolled ? 13 : 15, fontWeight: 700, letterSpacing: "0.06em", color: "#FFFFFF", lineHeight: 1.1, transition: "font-size 0.4s ease" }}>
                SYNTROPY
              </div>
              <div style={{ fontSize: scrolled ? 8 : 9, fontWeight: 500, letterSpacing: "0.25em", color: C.limeGreen, textTransform: "uppercase", transition: "font-size 0.4s ease" }}>
                ALLIANCE TRADE
              </div>
            </div>
          </div>

          {/* Desktop Nav */}
          <nav className="desktop-nav" style={{ display: "flex", gap: 36, alignItems: "center" }}>
            {NAV_LINKS.map((link) => (
              <a key={link} href={`${link.toLowerCase()}`}
                style={{ fontSize: 12, letterSpacing: "0.14em", textTransform: "uppercase", color: "rgba(230,203,161,0.7)", fontWeight: 500, transition: "color 0.2s" }}
                onMouseEnter={(e) => (e.target.style.color = C.limeGreen)}
                onMouseLeave={(e) => (e.target.style.color = "rgba(230,203,161,0.7)")}>
                {link.replace(/#\//g, "")}
              </a>
            ))}
            <a key="affiliate-dashboard-link" href="affiliate-dashboard"
              style={{ fontSize: 12, letterSpacing: "0.14em", textTransform: "uppercase", color: "rgba(230,203,161,0.7)", fontWeight: 500, transition: "color 0.2s" }}
              onMouseEnter={(e) => (e.target.style.color = C.limeGreen)}
              onMouseLeave={(e) => (e.target.style.color = "rgba(230,203,161,0.7)")}>
              Affiliate Dashboard
            </a>
            <a href="/shop" style={{ padding: "10px 24px", background: `linear-gradient(135deg,${C.limeGreen},${C.oliveGreen})`, color: C.darkGreen, borderRadius: 3, fontSize: 11, fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", textDecoration: "none", display: "inline-block" }}>
              Shop Now
            </a>
          </nav>

          {/* Burger Button (mobile only) */}
          <button
            className={`burger-btn${menuOpen ? " open" : ""}`}
            onClick={() => setMenuOpen((o) => !o)}
            aria-label="Toggle menu"
          >
            <span />
            <span />
            <span />
          </button>
        </div>

        {/* Mobile Dropdown Menu */}
        {isMobile && menuOpen && (
          <nav style={{
            display: "flex",
            flexDirection: "column",
            gap: 0,
            borderTop: `1px solid rgba(154,202,68,0.12)`,
            animation: "slideDown 0.22s ease",
          }}>
            {NAV_LINKS.map((link) => (
              <a
                key={link}
                href={`${link.toLowerCase()}`}
                onClick={() => setMenuOpen(false)}
                style={{
                  fontSize: 13, letterSpacing: "0.14em", textTransform: "uppercase",
                  color: "rgba(230,203,161,0.75)", fontWeight: 500,
                  padding: "14px 20px",
                  borderBottom: `1px solid rgba(154,202,68,0.08)`,
                  transition: "color 0.2s, background 0.2s",
                }}
                onMouseEnter={(e) => { e.currentTarget.style.color = C.limeGreen; e.currentTarget.style.background = "rgba(154,202,68,0.06)"; }}
                onMouseLeave={(e) => { e.currentTarget.style.color = "rgba(230,203,161,0.75)"; e.currentTarget.style.background = "transparent"; }}
              >
                {link.replace(/#\//g, "")}
              </a>
            ))}
            <a
              href="affiliate-dashboard"
              onClick={() => setMenuOpen(false)}
              style={{
                fontSize: 13, letterSpacing: "0.14em", textTransform: "uppercase",
                color: "rgba(230,203,161,0.75)", fontWeight: 500,
                padding: "14px 20px",
                borderBottom: `1px solid rgba(154,202,68,0.08)`,
                transition: "color 0.2s, background 0.2s",
              }}
              onMouseEnter={(e) => { e.currentTarget.style.color = C.limeGreen; e.currentTarget.style.background = "rgba(154,202,68,0.06)"; }}
              onMouseLeave={(e) => { e.currentTarget.style.color = "rgba(230,203,161,0.75)"; e.currentTarget.style.background = "transparent"; }}
            >
              Affiliate Dashboard
            </a>
            <div style={{ padding: "14px 20px" }}>
              <a
                href="/shop"
                onClick={() => setMenuOpen(false)}
                style={{
                  display: "block", textAlign: "center",
                  padding: "12px 24px",
                  background: `linear-gradient(135deg,${C.limeGreen},${C.oliveGreen})`,
                  color: C.darkGreen, borderRadius: 3,
                  fontSize: 12, fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase",
                }}
              >
                Shop Now
              </a>
            </div>
          </nav>
        )}
      </header>

      {/* ═══════════════════════════════════════════ HERO */}
      <section id="hero" style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", textAlign: "center", padding: isMobile ? "170px 18px 56px" : "120px 24px 80px", position: "relative", overflow: "hidden" }}>
        {/* Background elements */}
        {/* <div className="blob" style={{ width: 600, height: 600, background: C.darkGreen, top: "10%", left: "-15%" }} />
        <div className="blob" style={{ width: 400, height: 400, background: C.limeGreen, top: "20%", right: "-10%", opacity: 0.08 }} />
        <div className="blob" style={{ width: 500, height: 500, background: C.darkGreen, bottom: "-10%", left: "30%" }} /> */}

        {/* Subtle grid */}
        {/* <div style={{ position: "absolute", inset: 0, backgroundImage: `linear-gradient(rgba(154,202,68,0.04) 1px,transparent 1px),linear-gradient(90deg,rgba(154,202,68,0.04) 1px,transparent 1px)`, backgroundSize: "56px 56px", pointerEvents: "none" }} /> */}

        <div style={{ position: "relative", maxWidth: 820 }}>
          {/* Logo large in hero */}
          <div style={{ display: "flex", justifyContent: "center", marginBottom: 36, animation: "fadeUp 0.8s ease both" }}>
            <img
              src={LOGO_SRC}
              alt="Syntropy Alliance Trade"
              style={{ height: isMobile ? 82 : 110, width: "auto", filter: "drop-shadow(0 8px 32px rgba(154,202,68,0.35))", animation: "floatUp 5s ease-in-out infinite" }}
            />
          </div>

          <div style={{ display: "inline-block", padding: "5px 18px", border: `1px solid rgba(154,202,68,0.4)`, borderRadius: 100, fontSize: 10, letterSpacing: "0.28em", textTransform: "uppercase", color: C.limeGreen, marginBottom: 24, animation: "fadeUp 0.8s 0.1s ease both" }}>
            Premium Health &amp; Wellness Products
          </div>

          {/* <h1 style={{ fontSize: "clamp(38px,6.5vw,82px)", fontWeight: 300, lineHeight: 1.08, color: C.white, marginBottom: 22, animation: "fadeUp 0.9s 0.15s ease both", fontFamily: "'Playfair Display', serif" }}>
            Where Nature's{" "}
            <span style={{ color: C.limeGreen, fontStyle: "italic" }}>Intelligence</span>
            <br />Meets Modern Science
          </h1> */}
          <h1 style={{ fontSize: "clamp(38px,6.5vw,82px)", fontWeight: 300, lineHeight: 1.08, color: C.white, marginBottom: 22, animation: "fadeUp 0.9s 0.15s ease both", fontFamily: "'Playfair Display', serif" }}>
            Rooted in Purpose.{" "}
            <span style={{ color: C.limeGreen, fontStyle: "italic" }}>Growing in Unity.</span>
            <br />Trading for Good.
            <br /><span style={{ color: C.limeGreen, fontStyle: "italic" }}>Powered by Digital Innovation.</span>
          </h1>

          {/* <p style={{ fontSize: 17, lineHeight: 1.75, color: C.textFaint, maxWidth: 560, margin: "0 auto 42px", animation: "fadeUp 1s 0.2s ease both" }}>
            Syntropy Alliance Trade brings together ancient botanical wisdom and clinical-grade precision — crafting products that help your body achieve true synergy.
          </p> */}
          <p style={{ fontSize: 17, lineHeight: 1.75, color: C.textFaint, maxWidth: 560, margin: "0 auto 42px", animation: "fadeUp 1s 0.2s ease both" }}>
            Syntropy Alliance Trade brings together natural products that help your body achieve true synergy.
          </p>

          {/* <div style={{ display: "flex", gap: 16, justifyContent: "center", flexWrap: "wrap", animation: "fadeUp 1s 0.3s ease both" }}>
            <a href="/shop" style={btnPrimary}
              onMouseEnter={(e) => { e.target.style.transform = "translateY(-2px)"; e.target.style.boxShadow = "0 10px 30px rgba(154,202,68,0.45)"; }}
              onMouseLeave={(e) => { e.target.style.transform = "none"; e.target.style.boxShadow = "0 4px 20px rgba(154,202,68,0.3)"; }}>
              Explore Products
            </a>
            <button style={btnOutline}
              onMouseEnter={(e) => { e.target.style.borderColor = C.limeGreen; e.target.style.color = C.limeGreen; }}
              onMouseLeave={(e) => { e.target.style.borderColor = "rgba(230,203,161,0.35)"; e.target.style.color = C.cream; }}>
              Our Science
            </button>
          </div> */}

          {/* Scroll cue */}
          <div style={{ marginTop: 64, display: "flex", flexDirection: "column", alignItems: "center", gap: 8, opacity: 0.4, animation: "fadeUp 1s 0.6s ease both" }}>
            <div style={{ width: 1, height: 48, background: `linear-gradient(to bottom,transparent,${C.limeGreen})` }} />
            <span style={{ fontSize: 9, letterSpacing: "0.2em", textTransform: "uppercase", color: C.limeGreen }}>Scroll</span>
          </div>
        </div>
      </section>

      {/* ═══════════════════════════════════════════ STATS */}
      {/* ═══════════════════════════════════════════ HIDE STATS FOR NOW :: NEED MORE DETAILS */}
      {/* <div style={{ borderTop: `1px solid ${C.borderFaint}`, borderBottom: `1px solid ${C.borderFaint}`, display: "grid", gridTemplateColumns: "repeat(4,1fr)", textAlign: "center" }}>
        {STATS.map((st, i) => (
          <div key={st.label} style={{ padding: "36px 24px", borderRight: i < 3 ? `1px solid ${C.borderFaint}` : "none" }}>
            <div style={{ fontSize: 40, fontWeight: 300, color: C.limeGreen, lineHeight: 1, marginBottom: 6, fontFamily: "'Playfair Display', serif" }}>{st.value}</div>
            <div style={{ fontSize: 11, letterSpacing: "0.18em", textTransform: "uppercase", color: "rgba(230,203,161,0.45)" }}>{st.label}</div>
          </div>
        ))}
      </div> */}

      {/* ═══════════════════════════════════════════ BENEFITS */}
      <section id="benefits" style={{ padding: isMobile ? "64px 20px" : "100px 60px", maxWidth: 1240, margin: "0 auto" }} ref={setRef("benefits")} data-section="benefits">
        <div style={{ display: "grid", gridTemplateColumns: isTablet ? "1fr" : "1fr 2fr", gap: isTablet ? 30 : 80, alignItems: "start" }}>
          <div style={{ position: isTablet ? "static" : "sticky", top: 120 }}>
            <div style={sectionTag}>Why Choose Syntropy Alliance</div>
            <h2 style={sectionHead}>Health Benefits<br /><span style={{ color: C.limeGreen, fontStyle: "italic", fontFamily: "'Playfair Display', serif" }}>That Go Deep</span></h2>
            <p style={{ fontSize: 15, color: C.textFaint, lineHeight: 1.75, marginBottom: 32 }}>
              {/* Each formula targets root causes — not symptoms — working at the cellular level to support whole-body wellness. */}
            </p>
            <a href="/shop" style={btnPrimary}
              onMouseEnter={(e) => { e.target.style.transform = "translateY(-2px)"; }}
              onMouseLeave={(e) => { e.target.style.transform = "none"; }}>
              View All Products
            </a>
          </div>

          <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: 20 }}>
            {BENEFITS.map((b, i) => (
              <div key={b.title} style={{
                padding: "30px 28px",
                border: `1px solid ${C.borderFaint}`,
                borderRadius: 6,
                background: C.cardBg,
                opacity: visible("benefits") ? 1 : 0,
                transform: visible("benefits") ? "translateY(0)" : "translateY(28px)",
                transition: `opacity 0.55s ${i * 0.09}s ease, transform 0.55s ${i * 0.09}s ease`,
                cursor: "default",
              }}
                onMouseEnter={(e) => { e.currentTarget.style.borderColor = "rgba(154,202,68,0.45)"; e.currentTarget.style.background = "rgba(154,202,68,0.05)"; }}
                onMouseLeave={(e) => { e.currentTarget.style.borderColor = C.borderFaint; e.currentTarget.style.background = C.cardBg; }}>
                {/* <span style={{ fontSize: 30, marginBottom: 14, display: "block" }}>{b.icon}</span> */}
                <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 8, color: C.white }}>{b.title}</div>
                <div style={{ fontSize: 14, lineHeight: 1.7, color: C.textFaint }}>{b.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══════════════════════════════════════════ BRAND STRIPE */}
      <div style={{ background: "linear-gradient(135deg,#FFFFFF,#EDF6E3)", padding: isMobile ? "40px 20px" : "64px 60px", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 32, borderTop: `1px solid rgba(154,202,68,0.15)`, borderBottom: `1px solid rgba(154,202,68,0.15)` }}>
        <div style={{ display: "flex", alignItems: "center", gap: 24, flexWrap: "wrap" }}>
          <img src={LOGO_SRC} alt="" style={{ height: 64, width: "auto", filter: "drop-shadow(0 4px 12px rgba(0,0,0,0.4))" }} />
          <div>
            <div style={{ fontSize: 22, fontWeight: 700, color: C.white, letterSpacing: "0.04em" }}>SYNTROPY ALLIANCE TRADE</div>
            <div style={{ fontSize: 12, color: C.limeGreen, letterSpacing: "0.2em", marginTop: 4 }}>HEALTH · NATURE · SCIENCE</div>
          </div>
        </div>
        <div style={{ maxWidth: 440 }}>
          <p style={{ fontSize: 16, lineHeight: 1.7, color: C.textFaint, fontStyle: "italic", fontFamily: "'Playfair Display', serif", fontWeight: 600 }}>
            "We believe true health is not the absence of disease, but the fullest expression of your body's innate potential."
          </p>
        </div>
        <a href="/affiliate-registration" style={{ ...btnPrimary, padding: "14px 36px" }}
          onMouseEnter={(e) => { e.target.style.transform = "translateY(-2px)"; }}
          onMouseLeave={(e) => { e.target.style.transform = "none"; }}>
          Join Our Community
        </a>
      </div>

      {/* ═══════════════════════════════════════════ TESTIMONIALS */}
      <section id="testimonials" style={{ padding: isMobile ? "70px 20px" : "100px 60px", textAlign: "center", position: "relative", overflow: "hidden" }}
        ref={setRef("testimonials")} data-section="testimonials">
        <div className="blob" style={{ width: 500, height: 500, background: C.limeGreen, top: "-20%", right: "-10%" }} />
        <div style={{ position: "relative", maxWidth: 1200, margin: "0 auto" }}>
          <div style={sectionTag}>Real Stories</div>
          <h2 style={{ ...sectionHead, margin: "0 auto 10px" }}>What Our Community Says</h2>

          {tStatus === "error" && (
            <p style={{ fontSize: 10, letterSpacing: "0.12em", color: "rgba(154,202,68,0.4)", marginBottom: 20 }}>
              ⚠ Showing sample testimonials — connect your WordPress API to display live data
            </p>
          )}
          {tStatus === "success" && (
            <p style={{ fontSize: 10, letterSpacing: "0.12em", color: "rgba(154,202,68,0.5)", marginBottom: 20 }}>
              ✓ Live from WordPress
            </p>
          )}
          {tStatus === "loading" && <div style={{ height: 20 }} />}

          {/* Skeleton */}
          {tStatus === "loading" && <TestimonialSkeleton />}

          {/* Video grid */}
          {tStatus !== "loading" && testimonials.length > 0 && (
            <div style={{ 
              display: "grid", 
              // Uses 1 column for mobile, 2 columns for desktop
              gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", 
              gap: isMobile ? "20px" : "32px", 
              marginTop: "40px", 
              textAlign: "left", 
              maxWidth: isMobile ? "100%" : "1000px", 
              margin: "40px auto 0",
              padding: isMobile ? "0 4px" : "0" // Prevents videos from touching screen edges
            }}>
              {testimonials.map((item, i) => (
                <div
                  key={`${item.src}-${i}`}
                  style={{
                    borderRadius: 16,
                    overflow: "hidden",
                    background: "#000",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                  }}
                >
                  <video
                    controls
                    playsInline
                    preload="metadata"
                    style={{
                      width: "100%",
                      display: "block",
                      aspectRatio: "16 / 9", 
                      objectFit: "contain"
                    }}
                  >
                    <source src={item.src} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* ═══════════════════════════════════════════ CTA */}
      <section style={{ padding: isMobile ? "80px 20px" : "110px 60px", textAlign: "center", position: "relative", overflow: "hidden", background: "linear-gradient(160deg,#FFFFFF 0%,#EDF6E3 100%)" }}>
        <div className="blob" style={{ width: 700, height: 400, background: C.limeGreen, top: "50%", left: "50%", transform: "translate(-50%,-50%)", opacity: 0.06 }} />
        <div style={{ position: "relative" }}>
          <div style={sectionTag}>Begin Your Journey</div>
          <h2 style={{ ...sectionHead, maxWidth: "100%", margin: "0 auto 18px", fontSize: "clamp(32px,4.5vw,58px)" }}>
            Your Best Self Is{" "}
            <span style={{ color: C.limeGreen, fontStyle: "italic", fontFamily: "'Playfair Display', serif" }}>Within Reach</span>
          </h2>
          <p style={{ fontSize: 16, color: C.textFaint, maxWidth: 460, lineHeight: 1.75, margin: "0 auto 44px" }}>
            Join thousands of people who've chosen Syntropy Alliance Trade as their trusted partner in health and vitality.
          </p>
          <div style={{ display: "flex", gap: 16, justifyContent: "center", flexWrap: "wrap" }}>
            <a href="/shop" style={{ ...btnPrimary, fontSize: 14, padding: "16px 48px" }}
              onMouseEnter={(e) => { e.target.style.transform = "translateY(-2px)"; e.target.style.boxShadow = "0 12px 36px rgba(154,202,68,0.45)"; }}
              onMouseLeave={(e) => { e.target.style.transform = "none"; e.target.style.boxShadow = "0 4px 20px rgba(154,202,68,0.3)"; }}>
              Shop Our Products
            </a>
            {/* <button style={{ ...btnOutline, padding: "16px 36px" }}
              onMouseEnter={(e) => { e.target.style.borderColor = C.cream; e.target.style.color = C.cream; }}
              onMouseLeave={(e) => { e.target.style.borderColor = "rgba(230,203,161,0.35)"; e.target.style.color = C.cream; }}>
              Learn More
            </button> */}
          </div>
        </div>
      </section>

      {/* ═══════════════════════════════════════════ FOOTER */}
      <footer style={{ background: C.darkGreen, borderTop: `1px solid rgba(154,202,68,0.15)` }}>
        <div style={{ maxWidth: 1200, margin: "0 auto", padding: isMobile ? "36px 20px 24px" : "52px 60px 36px", display: "grid", gridTemplateColumns: isMobile ? "1fr" : isTablet ? "repeat(2,1fr)" : "2fr 1fr 1fr 1fr", gap: isMobile ? 30 : 48 }}>
          {/* Brand col */}
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20 }}>
              <img src={LOGO_SRC} alt="SATP" style={{ height: 44, width: "auto" }} />
              <div>
                <div style={{ fontSize: 13, fontWeight: 700, color: "#FFFFFF", letterSpacing: "0.06em" }}>SYNTROPY</div>
                <div style={{ fontSize: 8, letterSpacing: "0.22em", color: C.limeGreen }}>ALLIANCE TRADE</div>
              </div>
            </div>
            <p style={{ fontSize: 13, lineHeight: 1.7, color: "rgba(230,203,161,0.5)", maxWidth: 240 }}>
              {/* Science-backed wellness products crafted from nature's finest ingredients. */}
              Rooted in Purpose. Growing in Unity. Trading for Good. Powered by Digital Innovation.​
            </p>
          </div>

          {/* Links */}
          {[
            // { title: "Products",  links: ["Health Supplements", "Herbal Blends", "Bundles", "New Arrivals"] },
            // { title: "Company",   links: ["About Us", "Our Science", "Sustainability", "Careers"] },
            { title: "Company",   links: ["About Us"] },
            { title: "Support",   links: ["Contact", "FAQ"] },
          ].map((col) => (
            <div key={col.title}>
              <div style={{ fontSize: 11, letterSpacing: "0.18em", textTransform: "uppercase", color: C.limeGreen, marginBottom: 18, fontWeight: 600 }}>{col.title}</div>
              <ul style={{ listStyle: "none", display: "flex", flexDirection: "column", gap: 10 }}>
                {
                  col.title === "Company"
                    ? <li key="company__about-us">
                        <a href="#/about" style={{ fontSize: 13, color: "rgba(230,203,161,0.45)", transition: "color 0.2s" }}
                          onMouseEnter={(e) => (e.target.style.color = "rgba(230,203,161,0.85)")}
                          onMouseLeave={(e) => (e.target.style.color = "rgba(230,203,161,0.45)")}>
                          About Us
                        </a>
                      </li>
                    : ""
                }

                {
                  col.title === "Support"
                    ? <li key="support__contact">
                        <a href="#/contact" style={{ fontSize: 13, color: "rgba(230,203,161,0.45)", transition: "color 0.2s" }}
                          onMouseEnter={(e) => (e.target.style.color = "rgba(230,203,161,0.85)")}
                          onMouseLeave={(e) => (e.target.style.color = "rgba(230,203,161,0.45)")}>
                          Contact
                        </a>
                      </li>
                    : ""
                }
                {
                  col.title === "Support"
                    ? <li key="support__faq">
                        <a href="#/faq" style={{ fontSize: 13, color: "rgba(230,203,161,0.45)", transition: "color 0.2s" }}
                          onMouseEnter={(e) => (e.target.style.color = "rgba(230,203,161,0.85)")}
                          onMouseLeave={(e) => (e.target.style.color = "rgba(230,203,161,0.45)")}>
                          FAQ
                        </a>
                      </li>
                    : ""
                }

                {/* BACKUP */}
                {/* {col.links.map((l) => (
                  <li key={l}>
                    <a href="#" style={{ fontSize: 13, color: "rgba(230,203,161,0.45)", transition: "color 0.2s" }}
                      onMouseEnter={(e) => (e.target.style.color = C.cream)}
                      onMouseLeave={(e) => (e.target.style.color = "rgba(230,203,161,0.45)")}>
                      {l}
                    </a>
                  </li>
                ))} */}
              </ul>
            </div>
          ))}
        </div>

        <div style={{ borderTop: `1px solid rgba(154,202,68,0.1)`, padding: isMobile ? "16px 20px" : "20px 60px", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12 }}>
          <span style={{ fontSize: 12, color: "rgba(230,203,161,0.3)" }}>© 2026 Syntropy Alliance Trade. All rights reserved.</span>
          <div style={{ display: "flex", gap: 24 }}>
            {["Privacy Policy", "Terms of Use", "Refund Policy"].map((l) => (
              <a key={l} href="#" style={{ fontSize: 11, color: "rgba(230,203,161,0.3)", letterSpacing: "0.08em", transition: "color 0.2s" }}
                onMouseEnter={(e) => (e.target.style.color = C.limeGreen)}
                onMouseLeave={(e) => (e.target.style.color = "rgba(230,203,161,0.3)")}>
                {l}
              </a>
            ))}
          </div>
        </div>
      </footer>
    </div>
  );
}
